export function mapOrUndefined<T, K>(
  value: T | null | undefined,
  callbackFn: (v: T) => K
): K | null | undefined {
  if (value === null) {
    return null;
  }
  if (value === undefined) {
    return undefined;
  }

  return callbackFn(value);
}
